import React from 'react'
import { getSetting, setSetting, reloadSettings, apiGet, getGlobal, setGlobal,
  apiPost, Input, TextEditor, helpers, notify, confirm } from 'launchpad'
import styled from 'styled-components'
import Createable from 'react-select/lib/Creatable'
import Select from 'react-select'
import Switch from '@material-ui/core/Switch'
import _ from 'lodash'

let dataStores = {}

export const DataStore = (label, options) => {
  if(options && options.noCache) return new DataStoreClass(label, options)
  if(!dataStores[label]){
    dataStores[label] = new DataStoreClass(label, options)
  }
  return dataStores[label]
}




// store/retrieve data, loaded lazily
let loadedStores = []

let globalUpdate;

let listeners = {

}

const subscribeToStore = (store, component) => {
  if(!listeners[store]) listeners[store] = []
  if(!listeners[store].includes(component)) {
    listeners[store].push(component)
  }
}

const unsubscribeFromStore = (store, component) => {
  if(listeners[store]){
    listeners[store] = listeners[store].filter(x => x != component)
  }
}

const storeToState = (store, val) => {
  let DataStores = getGlobal('DataStores') || {}
  try {
    DataStores[store] = val
    setGlobal({ DataStores })
    if(listeners[store]){
      listeners[store].forEach(l => l.forceUpdate())
    }
  } catch(e) {
    console.error(e)
  }
}

const loadStore = (store) => {
  if(!loadedStores.includes(store)){
    apiGet('data-stores/'+store).then(data => {
      let value = []
      if(data) {
        value = JSON.parse(data.value)
      }
      storeToState(store, value)
    })
    loadedStores.push(store)
  }

}

let timers = {}
const setStore = (store, value, cb) => {
  storeToState(store, value)
  clearTimeout(timers[store])
  timers[store] = setTimeout(() => {
    apiPost('data-stores/'+store, {value: JSON.stringify(value)}).then(cb)
  }, 200)

}

const getStore = (store) => {
  loadStore(store)
  return (getGlobal('DataStores') && getGlobal('DataStores')[store]) || []
}





// Core DataStore class
class DataStoreClass {
  constructor(label, options) {
    this.label = label
    this.options = options || {}
  }

  itemId = 1

  subscribe = (component) => {
    subscribeToStore(this.label, component)
  }

  unsubscribe = (component) => {
    unsubscribeFromStore(this.label, component)
  }

  getItemId = () => {
    this.itemId++
    return this.itemId
  }

  get = (id) => {
    const items = this.getAll()
    return items.find(r => r.id == id)
  }

  query = (query) => {
    const item = this.getAll().find(x => {
      let isMatch = true
      Object.keys(query).forEach(key => {
        if(x[key] && x[key] != query[key]){
          isMatch = false
        }
      })
      return isMatch
    })
    return item
  }

  checked = false

  getAll = (check) => {
    let items;
    if(this.options.get){
      items = this.options.get()
    } else {
      items = getStore(this.label)
    }

    if(!this.checked){
      if(items.length) this.checked = true
      items.forEach(r => {
        if(r && this.itemId <= r.id){
          this.itemId = r.id + 1
        }
      })

      // ensure all items have a unique id
      items = items.map(r => {
        if(!r.id) r.id = this.getItemId()
        return r
      })
    }

    return items
  }

  set = (items, cb) => {
    let filteredItems = []
    items.forEach(r => {
      if(r) filteredItems.push(r)
    })
    if(this.options.set){
      this.options.set(filteredItems)
    } else {
      setStore(this.label, filteredItems)
    }
  }

  add = (item, cb) => {
    let items = this.getAll()
    const id = this.getItemId()
    item.id = id
    items.push(item)
    this.set(items, cb)
    return id
  }

  // TODO: this function needs to be simplified
  update = (id, item, cb) => {
    let items = this.getAll()
    let newItems = items
    if(!this.get(id)) {
      // create item with id if not exists
      item.id = id
      newItems = newItems.concat(item)
    } else {
      newItems = newItems.map(r => {
        if(r.id == id) {
          r = Object.assign({}, r, item, {id: id})
        }
        return r
      })
    }

    this.set(newItems, cb)
  }

  addOrUpdate = (query, update, cb) => {
    const item = this.query(query)
    if(item) {
      this.update(item.id, Object.assign({}, item, update), cb)
    } else {
      this.add(Object.assign({}, query, update), cb)
    }
  }

  delete = (id) => {
    confirm('Are you sure you want to delete this item?', ()=>{
      let items = this.getAll()
      this.set(items.map(r => {
        if(r && r.id != id) return r
      }))
    })
  }

  newForm(submit) {
    return <ItemForm frontEnd={this.options.frontEnd} schema={this.options && this.options.schema} model={this} onSubmit={submit}/>
  }

  editForm(id, submit) {
    return <ItemForm frontEnd={this.options.frontEnd} itemId={id} schema={this.options && this.options.schema} model={this} onSubmit={submit}/>
  }
}



const IconStyles = styled.div`
  display: flex;
  .icon {
    border: 2px solid transparent;
    cursor: pointer;
    .fa {
      border: 1px dashed #ddd;
      padding: 5px;
      font-size: 15px;
      min-width: 25px;
    }
    &.selected {
      border: 2px solid black;

    }
  }
`

// may move this if it looks useful elsewhere
export class IconSelector extends React.Component {
  state = {selected: ''}
  icons = ['check', 'gear', 'bell', 'asterisk', 'comments-o', 'dot-circle-o', 'feed', ]


  componentDidMount(){
    if(!this.state.selected){
      this.setState({selected: this.props.selected || ''})
    }
  }

  select = (icon) => {
    this.setState({selected: icon})
    this.props.onChange && this.props.onChange(icon)
  }

  render() {
    const selected = this.props.value || this.state.selected
    return <IconStyles>
      <div className={'icon '+ (!selected ? 'selected': '')} onClick={()=>this.select('') } >No Icon</div>
      {this.icons.map(icon => {
        return <div key={icon} className={'icon '+(selected == icon ? 'selected' : '')} onClick={()=>this.select(icon) } >
          <div className={'fa fa-'+icon} />
        </div>
      })}
    </IconStyles>
  }
}

// Automatically generated form based on provided schema (if provided)
const RForm = styled.div`
  padding: 10px;
  .submit {
    text-align: right;
    margin-top: 20px;
  }
  .error {
    color: red;
  }
  .field {
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 3px;
    padding: 5px;
    .field-label {
      padding: 3px;
      margin: 0 -3px;
      border-bottom: 1px solid #ddd;
      display: block;
      margin-bottom: 3px;
      margin-top: -3px;
      font-size: .8rem;
      color: #555;
    }
    .field-container {
      border-top: 1px solid #ddd;
      margin: -5px;
    }
    input {
      width: 100%;
      border-radius: 3px;
      border: 0;
      font-size: 1.1rem;
      padding: 7px;
    }
    .text-editor {
      padding: 5px;
      min-height: 4rem;
    }
  }
`

const Field = (props) => <div className={props.className}>
  <label className='field-label'>{props.label}</label>
  <div className='field-container'>
    {props.children}
  </div>
</div>

export class ItemForm extends React.Component {
  constructor(props) {
    super(props)
    this.defaultState = {errors: []}
    Object.keys(props.schema).forEach(key =>{
      const s = props.schema[key]
      this.defaultState[key] = s.default || ((s.type == 'boolean' || s == 'boolean') ? false : '')
    })
    this.state = Object.assign({}, this.defaultState)
  }

  componentDidMount() {
    this.reset()
  }

  componentDidUpdate(prevProps) {
    if(this.props.item && (!prevProps.item || this.props.item._id != prevProps.item._id)){
      this.reset()
    }
  }

  reset = () => {
    if (this.props.item) {
      this.defaultState = this.props.item
    }
    if (this.props.itemId) {
      this.defaultState = this.props.model.get(this.props.itemId)
    }
    this.setState(this.defaultState)
  }

  validate = () => {
    const { schema } = this.props
    let errors = []
    if(schema){
      Object.keys(schema).forEach(key=>{
        if((schema[key] == 'number' || schema[key].type == 'number') && isNaN(this.state[key])){
          notify(`"${helpers.getTitle(key)}" must be a number`)
          errors.push(key)
        }
        if(schema[key].optional != false && !schema[key] == Boolean){
          if(!this.state[key]) {
            errors.push(key)
          }
        }
      })
    }
    this.setState({ errors })
    return (errors.length === 0)
  }

  submit = (e) => {
    let toPush = Object.assign({}, this.state)
    if(toPush.errors) delete toPush.errors
    e.preventDefault()
    if(this.validate()){
      if(this.props.overrideSubmit){
        this.props.overrideSubmit(toPush)
        return
      }
      if (this.props.itemId) {
        this.props.model.update(this.props.itemId, toPush, () => this.reset())
      } else {
        this.props.model.add(toPush)
        this.reset()
      }
      this.props.onSubmit && this.props.onSubmit()
      this.props.resetOnSubmit && this.reset()
    }
  }

  getOptions = (field) => {
    const {selectOptions, schema} = this.props
    if(schema[field].options) return schema[field].options
    if(selectOptions && selectOptions[field]){
      return selectOptions[field]
    } else {
      if(this.props.model){
        let optionValues = []
        let options = []
        this.props.model.getAll().forEach(item => {
          if(!optionValues.includes(item[field].value)){
            options.push(item[field]);
            optionValues.push(item[field].value)
          }
        })
        return options
      } else {
        return []
      }
    }
  }

  resetError = (field) => {
    if(this.state.errors.includes(field)){
      this.setState({errors: this.state.errors.filter(k=>k!=field)})
    }
  }

  update = (key, value) => {
    const update = {[key]: value}
    if(this.props.onUpdate){
      const newState = this.props.onUpdate(this.state, Object.assign({}, this.state, update))
      this.setState(newState)
    } else {
      this.setState(update)
    }
    this.resetError(key)
  }

  render() {
    return this.props.schema
      ? <RForm onSubmit={this.submit}>
        {Object.keys(this.props.schema).map(key => {
          const o = this.props.schema[key]
          let type = 'text'
          if(typeof o == 'string'){
            type = o
          } else {
            if(o.type) type = o.type
          }
          let defaultProps = {
            value: this.state[key] && this.state[key]._id ? this.state[key]._id : this.state[key],
            onChange: value => this.update(key, value),
            onFocus: e => this.resetError(key),
          }
          let cn = 'field'
          if(this.state.errors.includes(key)){
            defaultProps.error = true
            cn += ' error'
          }

          if(type == 'options') {
            defaultProps.value = {value: defaultProps.value, label: (this.getOptions(key).find(x=>x.value == defaultProps.value) || {}).label}
            defaultProps.onChange = v => this.update(key, v.value)
          }

          if(type == 'list'){
            defaultProps.value = (this.state[key] || []).map(o => {return {label: o, value: o}})
            defaultProps.onChange = v => this.update(key, v.map(x => x.value))
          }

          const fieldProps = {
            className: cn,
            key: key,
            label: helpers.getTitle(key)
          }

          const InputText = this.props.frontEnd
            ? <Field {...fieldProps}>
                <input {...defaultProps}
                  placeholder={fieldProps.label + (o.optional ? ' (optional)' : '')}
                  onChange={e=>this.setState({[key]: e.target.value})}
                />
              </Field>
            : <Input {...fieldProps} {...defaultProps} onChange={(e, v) => this.update(key, v)}/>


          switch(type) {
            case 'text':
              return InputText

            case 'number':
              return InputText

            case 'textarea':
              return <Field {...fieldProps}><TextEditor {...defaultProps} /></Field>

            // TODO: names for these are confusing, 'select' should be Select, something else for Creatable
            case 'select':
              return <Field {...fieldProps}><Createable {...defaultProps} options={this.getOptions(key)} /></Field>

            case 'options':
              return <Field {...fieldProps}><Select {...defaultProps} options={this.getOptions(key)} /></Field>

            case 'list':
              return <Field {...fieldProps}><Createable isMulti {...defaultProps} options={this.getOptions(key)} /></Field>

            case 'icon':
              return <Field {...fieldProps}><IconSelector {...defaultProps}/></Field>

            case 'boolean':
              return <Field {...fieldProps}>
                <Switch
                  color='primary' {...defaultProps}
                  checked={this.state[key]}
                  onChange={(e, v)=>this.update(key, v)}
                />
              </Field>
          }
        })}
        <div className='submit'>
          <button onClick={this.submit}>Submit</button>
        </div>
      </RForm>
      : <div>You must provide a schema to DataStore options to use auto-generated edit form</div>
  }
}
